import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { QMonthHistoryParams, QMonthHistoryResponse } from "./qMonthHistoryAPI.types";

export const qMonthHistoryApi = createApi({
  reducerPath: "qMonthHistoryApi",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getQMonthHistory: builder.query<QMonthHistoryResponse, QMonthHistoryParams>({
      query: (params) => {
        const { Aff, Abo, Period, IsoCountryCode, IsoCurrencyCode, Locale } = params;
        const queryParams = new URLSearchParams({
          Abo: Abo,
          Aff: Aff,
          Period: Period,
          IsoCountryCode: IsoCountryCode,
          IsoCurrencyCode: IsoCurrencyCode,
          Locale: Locale,
        });

        return `/incentives-v2/api/qmonthhistory/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetQMonthHistoryQuery } = qMonthHistoryApi;
